<div class="number-input-container" (focusin)="onFocusIn()" (focusout)="onFocusOut($event)">
    <input
        matInput
        [placeholder]="_placeholder"
        [formControl]="inputValueControl"
        (beforeinput)="onBeforeInput($event)"
        (input)="onInput($event)"
    />
    <mat-icon
        matSuffix
        *ngIf="displayWarningTriangle"
        class="triangle-warning"
        svgIcon="aumico-pattern-icon-alert-triangle"
    ></mat-icon>
</div>
